import React from 'react';
import Picture from '@exp/common/src/components/picture/Picture';
import parse from 'html-react-parser';
import './boost-score.scss';
type BoostScoreProps = {
  className?: string;
  message?: string;
};

class BoostScore extends React.Component<BoostScoreProps> {
  constructor(props: BoostScoreProps) {
    super(props);
  }
  render() {
    const cl = this.props.className || '';

    return (
      <div
        id="score-gauge"
        className={`d-md-flex flex-wrap position-relative ${cl}`}>
        {this.props.message && (
          <p className="boost-msn order-3 w-md-100 text-center mb-md-0 mt-md-3 mt-lg-4 zoomIn h6">
            {parse(this.props.message)}
          </p>
        )}
        <div className="d-flex align-items-center justify-content-center d-md-block order-2 w-md-100">
          <div
            role="region"
            className="score lh-1 slideUp fw-medium">
            <span aria-label="If you boost your FICO® Score, you could jump into a higher score band, like this example, which shows a boost into the Good rating.">
              702
            </span>
          </div>
          <p className="ms-2 ms-md-0 mt-md-2 score-msn py-md-3 p-2 text-md-center h5 mb-0 zoomIn rounded-3 shadow-sm">
            Congrats! You got a <span className="text-green">boost</span>.
          </p>
        </div>

        <Picture
          className="order-1 w-md-100"
          sources={[
            {
              srcSet: `/graphics/graphic-score-band-good-white.svg`,
              media: 'md',
              width: '460',
              height: '270',
            },
          ]}
          image={{
            src: `/graphics/graphic-score-band-good-white-horiz.svg`,
            width: '290',
            height: '45',
            alt: 'Credit score gauge.',
            className: 'w-md-100 img-fluid d-block mx-auto slideUp',
          }}
        />
      </div>
    );
  }
}

export default BoostScore;
